function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M271.9,208.81h-5.22l-13.8-11.87a5.45,5.45,0,0,0-3.83-1.65,3.63,3.63,0,0,0-4,3.84c0,1.92,1,3.88,4.07,3.88v5.8c-5.81,0-9.29-4.24-9.29-9.68,0-5.63,3.53-9.64,9.24-9.64,3.08,0,4.73,1.2,7.28,3.39l10.31,8.88V189.49h5.22Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M272.17,175.07c0,5.18-3.4,9.69-9.47,9.69H249.31c-6.07,0-9.46-4.51-9.46-9.69s3.39-9.64,9.46-9.64H262.7C268.77,165.43,272.17,169.89,272.17,175.07Zm-22.77-3.84c-2.67,0-4.33,1.57-4.33,3.84s1.66,3.88,4.33,3.88h13.26c2.68,0,4.28-1.6,4.28-3.88s-1.6-3.84-4.28-3.84Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M271.9,160.34h-5.22l-13.8-11.87a5.45,5.45,0,0,0-3.83-1.65,3.63,3.63,0,0,0-4,3.84c0,1.92,1,3.88,4.07,3.88v5.8c-5.81,0-9.29-4.24-9.29-9.68,0-5.62,3.53-9.64,9.24-9.64,3.08,0,4.73,1.2,7.28,3.39l10.31,8.88V141h5.22Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M271.9,136.11h-5.22l-13.8-11.87a5.45,5.45,0,0,0-3.83-1.65,3.63,3.63,0,0,0-4,3.84c0,1.91,1,3.88,4.07,3.88v5.8c-5.81,0-9.29-4.24-9.29-9.68,0-5.63,3.53-9.64,9.24-9.64,3.08,0,4.73,1.2,7.28,3.39l10.31,8.88V116.79h5.22Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M318.1,208.7c-14.83,0-28.75-7.79-29-26.83H305.7c.26,8.18,5.88,11.88,12.4,11.88,7.15,0,12.26-4.47,12.26-12.65,0-7.54-4.6-12.52-12.77-12.52h-2.43V154.14h2.43c8.05,0,11.5-5,11.5-11.38,0-7.66-5.12-11.62-11.12-11.62-6.26,0-10.86,4.09-11.25,11H290.11c.39-16.23,12.52-25.94,27.86-25.94,16.1,0,27.73,10.73,27.73,26.06,0,9.84-4.47,15.47-10.48,18.66,6.52,3.45,11.76,9.71,11.76,20.7C347,199.76,333.69,208.7,318.1,208.7Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M361.8,207.94V189h19v18.92Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M424.28,208.7c-14.82,0-27.73-9.71-27.73-27.09V143.28c0-17.38,12.91-27.09,27.73-27.09s27.6,9.71,27.6,27.09v38.33C451.88,199,439.11,208.7,424.28,208.7Zm11-65.17c0-7.67-4.47-12.39-11-12.39s-11.11,4.72-11.11,12.39v37.95c0,7.67,4.6,12.27,11.11,12.27s11-4.6,11-12.27Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M514.63,168.58l-19.3,39.36h-18l18.91-37.57a18.07,18.07,0,0,1-6.77,1.15c-12.27,0-24-10.1-24-27,0-17.89,12.27-28.36,28.37-28.36s28.36,10.09,28.36,28.11C522.16,152.6,518.71,160.27,514.63,168.58ZM493.8,131.14C487,131.14,482,136,482,144.43c0,8,4.73,13.29,11.76,13.29,6.77,0,11.75-4.86,11.75-13.29S500.57,131.14,493.8,131.14Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M240.88,239.62v-18.1h11.93v3.15h-8.39v4.25h7.14v3.15h-7.14v4.4h8.39v3.15Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M265.83,239.62l-3.51-6.3-3.49,6.3h-4l5.62-9.28-5.26-8.82h4l3.16,5.85,3.18-5.85h4l-5.27,8.82,5.65,9.28Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M285.94,224.67v15H282.4v-15h-4.73v-3.15h13v3.15Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M303.71,239.62v-7.57h-6.13v7.57h-3.53v-18.1h3.53v7.4h6.13v-7.4h3.54v18.1Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M312,239.62v-18.1H323.9v3.15h-8.39v4.25h7.15v3.15h-7.15v4.4h8.39v3.15Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M338.17,239.62l-1.07-3.2h-6.43l-1.1,3.2h-3.68l6.58-18.1h2.77l6.62,18.1ZM334,226.86l-2.29,6.58h4.5Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M351.52,224.67v15H348v-15h-4.73v-3.15h13v3.15Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M359.63,239.62v-18.1h11.92v3.15h-8.39v4.25h7.15v3.15h-7.15v4.4h8.39v3.15Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M385.13,239.62l-3.53-7.22h-2.55v7.22h-3.53v-18.1h7.09c3.69,0,5.88,2.52,5.88,5.54a4.89,4.89,0,0,1-3.31,4.76l4.05,7.8Zm-2.74-15h-3.34v4.78h3.34a2.4,2.4,0,1,0,0-4.78Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M408.68,239.62l-3.54-7.22H402.6v7.22h-3.53v-18.1h7.09c3.69,0,5.87,2.52,5.87,5.54a4.89,4.89,0,0,1-3.3,4.76l4,7.8Zm-2.75-15H402.6v4.78h3.33a2.4,2.4,0,1,0,0-4.78Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M427.16,237.79a6.55,6.55,0,0,1-4.88,2,6.62,6.62,0,0,1-4.91-2c-1.83-1.83-1.78-4.09-1.78-7.22s0-5.39,1.78-7.22a6.61,6.61,0,0,1,4.91-2,6.54,6.54,0,0,1,4.88,2c1.83,1.83,1.81,4.09,1.81,7.22S429,236,427.16,237.79Zm-2.62-12.3a2.9,2.9,0,0,0-2.26-1,3,3,0,0,0-2.29,1c-.68.76-.86,1.6-.86,5.08s.18,4.32.86,5.09a3,3,0,0,0,2.29,1,2.93,2.93,0,0,0,2.26-1c.69-.77.89-1.61.89-5.09S425.23,226.25,424.54,225.49Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M440.11,232.81h-3.49v6.81h-3.53v-18.1h7a5.65,5.65,0,1,1,0,11.29Zm-.18-8.14h-3.31v5h3.31a2.48,2.48,0,1,0,0-5Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M456.58,232.81H453.1v6.81h-3.54v-18.1h7c3.74,0,6,2.57,6,5.64S460.32,232.81,456.58,232.81Zm-.18-8.14h-3.3v5h3.3a2.48,2.48,0,1,0,0-5Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M477,237.79a6.55,6.55,0,0,1-4.88,2,6.62,6.62,0,0,1-4.91-2c-1.83-1.83-1.78-4.09-1.78-7.22s-.05-5.39,1.78-7.22a6.61,6.61,0,0,1,4.91-2,6.54,6.54,0,0,1,4.88,2c1.83,1.83,1.81,4.09,1.81,7.22S478.83,236,477,237.79Zm-2.62-12.3a2.91,2.91,0,0,0-2.26-1,3,3,0,0,0-2.29,1c-.69.76-.86,1.6-.86,5.08s.17,4.32.86,5.09a3,3,0,0,0,2.29,1,2.94,2.94,0,0,0,2.26-1c.69-.77.89-1.61.89-5.09S475.07,226.25,474.38,225.49Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M493.63,239.62l-7.17-11.11v11.11h-3.54v-18.1h3.16l7.17,11.09V221.52h3.53v18.1Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M512.68,237.72a6.82,6.82,0,0,1-5.12,2.06,6.61,6.61,0,0,1-4.88-2,5.19,5.19,0,0,1-1.47-2.72,32.82,32.82,0,0,1,0-9,5.11,5.11,0,0,1,1.47-2.72,6.64,6.64,0,0,1,4.88-2,6.48,6.48,0,0,1,6.82,5.79h-3.56a3.08,3.08,0,0,0-3.26-2.64,2.87,2.87,0,0,0-2.26,1c-.66.83-.86,1.5-.86,5.08s.15,4.27.86,5.11a2.79,2.79,0,0,0,2.26.94,3.26,3.26,0,0,0,2.52-1,3.55,3.55,0,0,0,.82-2.42v-.69h-3.34v-2.95h6.85v2.65C514.41,234.84,513.92,236.39,512.68,237.72Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M518.22,239.62v-18.1h3.53v18.1Z",
  transform: "translate(-239.85 -116.19)",
  fill: "#fff"
});

function SvgDatetime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "99.59mm",
    height: "43.6mm",
    viewBox: "0 0 282.31 123.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatetime);
export default __webpack_public_path__ + "static/media/datetime.0b0ab381.svg";
export { ForwardRef as ReactComponent };